<script setup lang="ts">
/**
 * BaseTabs — generic tab bar used by BoardMembersView, ResidentApprovalsView, etc.
 *
 * Usage:
 *   <BaseTabs :tabs="tabs" :active="activeKey" @change="activeKey = $event" />
 */

defineProps<{
  tabs: { key: string; label: string; count?: number }[];
  active: string;
}>();

const emit = defineEmits<{
  change: [key: string];
}>();
</script>

<template>
  <div
    class="flex gap-0 border-b border-border overflow-x-auto scrollbar-none"
    role="tablist"
  >
    <button
      v-for="tab in tabs"
      :key="tab.key"
      role="tab"
      :aria-selected="tab.key === active"
      :class="[
        'px-4 py-2.5 text-body whitespace-nowrap border-b-2 -mb-px transition-colors',
        tab.key === active
          ? 'border-navy-800 text-fg font-semibold'
          : 'border-transparent text-muted hover:text-fg hover:border-border-strong',
      ]"
      @click="emit('change', tab.key)"
    >
      {{ tab.label }}
      <span
        v-if="tab.count !== undefined"
        class="font-mono tabular-nums text-muted ml-1 text-caption"
      >{{ tab.count }}</span>
    </button>
  </div>
</template>
